import { QuoteStatus } from '../../utils/QuoteStatus'
import type { LineItemType, QuoteData } from './types'

export const LINE_ITEM_TYPE_NAMES: Record<LineItemType, string> = {
  PC: 'Professional Component',
  TC: 'Technical Component',
  AN: 'Anesthesia',
  PT: 'Physical Therapy',
  MI: 'Miscellaneous',
}

export const LINE_ITEM_TYPE_ORDER: LineItemType[] = ['PC', 'TC', 'AN', 'PT', 'MI']

export const SCROLLABLE_MAX_HEIGHT = 600
export const SCROLL_CONTAINER_MIN_HEIGHT = 400

// Step 3 review grid column constants
export const STEP3_PT_GRID_COLUMNS = '2fr 100px 130px 110px 120px 100px'
export const STEP3_STANDARD_GRID_COLUMNS = '2fr 1fr 1.5fr 70px 110px 120px 100px'
// Step 2 (QuoteCardWithButtons) grid column constants
export const STEP2_PT_GRID_COLUMNS = '140px 80px 100px 80px 100px 80px'
export const STEP2_STANDARD_GRID_COLUMNS = '140px 100px 60px 1fr 90px 90px 90px'
// Step 1 (QuoteCard) grid column constants
export const STEP1_PT_GRID_COLUMNS = '24px 24px 140px 100px 110px 90px 100px 80px'
export const STEP1_STANDARD_GRID_COLUMNS =
  '24px 24px 140px 100px 60px 70px 100px 100px 90px'

export const EMPTY_ORIGINAL_QUOTE: QuoteData = {
  id: '',
  title: 'Original Provider Quote',
  patientName: '',
  dateOfBirth: new Date(0),
  bodyPart: '',
  eocLegacy: '',
  startDate: new Date(0),
  endDate: new Date(0),
  bundleDurationDays: 0,
  groupNumber: 0,
  status: QuoteStatus.Draft,
  lineItems: [],
  totalOriginalCost: 0,
  consumedCost: 0,
  type: 'Unknown',
}

export const EMPTY_CONSUMER_QUOTE: QuoteData = {
  ...EMPTY_ORIGINAL_QUOTE,
  title: 'Consumer Quote',
}
